import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// MOJ PROFIL komponente
import NaslovnaStran from 'src/components/Dashboard/Views/Domov/NaslovnaStran.vue'

// MOJ PROFIL komponente
import Osnovno from 'src/components/Dashboard/Views/Mojprofil/Osnovno.vue'
import T2klub from 'src/components/Dashboard/Views/Mojprofil/T2klub.vue'
import Druzabno from 'src/components/Dashboard/Views/Mojprofil/Druzabno.vue'
import Narocnine from 'src/components/Dashboard/Views/Mojprofil/Narocnine.vue'
import Varnost from 'src/components/Dashboard/Views/Mojprofil/Varnost.vue'

// MOJ T-2 komponente
import Dokumenti from 'src/components/Dashboard/Views/MojT2/Dokumenti.vue'
import Eposlovanje from 'src/components/Dashboard/Views/MojT2/Eposlovanje.vue'
import OsebniPodatkiInSoglasja from 'src/components/Dashboard/Views/MojT2/OsebniPodatkiInSoglasja.vue'
import Racuni from 'src/components/Dashboard/Views/MojT2/Racuni.vue'
import UporabnikiInPravice from 'src/components/Dashboard/Views/MojT2/UporabnikiInPravice.vue'
import NastavitveMojT2 from '../components/Dashboard/Views/Mojprofil/NastavitveMojT2'

// PORABA komponente
import PorabaHramba from 'src/components/Dashboard/Views/Poraba/PorabaHramba.vue'
import PorabaTelefonija from 'src/components/Dashboard/Views/Poraba/PorabaTelefonija.vue'
import PorabaTelevizija from 'src/components/Dashboard/Views/Poraba/PorabaTelevizija.vue'

// NAROČI komponente
import NarociHramba from 'src/components/Dashboard/Views/Naroci/NarociHramba.vue'
import NarociTelefonija from 'src/components/Dashboard/Views/Naroci/NarociTelefonija.vue'
import NarociTelevizija from 'src/components/Dashboard/Views/Naroci/NarociTelevizija.vue'
import NarociInternet from 'src/components/Dashboard/Views/Naroci/NarociInternet.vue'
import NarociT2Paket from 'src/components/Dashboard/Views/Naroci/NarociT2Paket.vue'
import NarociMobilnaTelefonija from 'src/components/Dashboard/Views/Naroci/NarociMobilnaTelefonija.vue'
import TVsmart from '../components/Dashboard/Views/Naroci/NarociTelevizija/TVsmart.vue'

// NASTAVITVE komponente
import NastavitveTelefonija from 'src/components/Dashboard/Views/Nastavitve/NastavitveTelefonija.vue'
import NastavitveTelevizija from 'src/components/Dashboard/Views/Nastavitve/NastavitveTelevizija.vue'
import NastavitveMreznaOprema from 'src/components/Dashboard/Views/Nastavitve/NastavitveMreznaOprema.vue'
import NastavitveElektronskaPosta from 'src/components/Dashboard/Views/Nastavitve/NastavitveElektronskaPosta.vue'
import SpletnaPredstavitev from 'src/components/Dashboard/Views/Nastavitve/SpletnaPredstavitev.vue'
import ClientServise from 'src/components/Dashboard/Views/Nastavitve/ClientServise.vue'
import T2Cloud from '../components/Dashboard/Views/Nastavitve/T2Cloud'

// UPORABNIŠKI KOTIČEK komponente
import OMojemT2 from 'src/components/Dashboard/Views/UporabniskiKoticek/OMojemT2.vue'
import UporabneStrani from 'src/components/Dashboard/Views/UporabniskiKoticek/UporabneStrani.vue'
import T2Aplikacije from 'src/components/Dashboard/Views/UporabniskiKoticek/T2Aplikacije.vue'
import PosljiSms from 'src/components/Dashboard/Views/UporabniskiKoticek/PosljiSms.vue'
import Ambasador from 'src/components/Dashboard/Views/UporabniskiKoticek/Ambasador.vue'

// PREPAID
// import PrepaidNarocnine from '../components/Dashboard/Views/Prepaid/Narocnine/Narocnine'


import {povezave} from '../assets/js/Povezave/povezave'
import {PrivzetaVrednostTipEnum} from '../assets/js/Enum/PrivzetaVrednostTipEnum.js'
import CookiesPage from '../components/Dashboard/Views/CookiesPage.vue'
import VarnostnaZascita from '../components/Dashboard/Views/Naroci/VarnostnaZascita.vue'


let MojProfil = {
  path: '/Mojprofil',
  component: DashboardLayout,
  redirect: '/Mojprofil/Narocnine',
  permissions: [],
  additionalDataRequired: false,
  children: [
    {
      path: 'Osnovno',
      name: 'Osnovno',
      component: Osnovno,
      permissions: ['NAROCNINE'],
      additionalDataRequired: false
    },
    {
      path: 'T2klub',
      name: 'T2klub',
      component: T2klub,
      permissions: ['PRIKLJUCKI'],
      additionalDataRequired: true
    },
    {
      path: 'Druzabno',
      name: 'Druzabno',
      component: Druzabno,
      permissions: ['NAROCNINE'],
      additionalDataRequired: false
    },
    {
      path: 'NastavitveMojT2',
      name: 'NastavitveMojT2',
      component: NastavitveMojT2,
      permissions: ['NAROCNINE'],
      additionalDataRequired: true
    },
    {
      path: 'Narocnine',
      name: 'Narocnine',
      component: Narocnine,
      permissions: ['STRANKE'],
      additionalDataRequired: false
    },
    {
      path: 'Varnost',
      name: 'Varnost',
      component: Varnost,
      permissions: ['NAROCNINE'],
      additionalDataRequired: false
    }
  ]
}

let racun = {
  path: '/MojT2',
  component: DashboardLayout,
  redirect: '/Mojprofil/Narocnine',
  permissions: [],
  additionalDataRequired: false,
  children: [
    {
      path: 'Dokumenti',
      name: 'Dokumenti',
      component: Dokumenti,
      permissions: ['STRANKE'],
      additionalDataRequired: true
    },
    {
      path: 'Eposlovanje',
      name: 'Eposlovanje',
      component: Eposlovanje,
      permissions: ['EPOSLOVANJE'],
      additionalDataRequired: true
    },
    {
      path: 'OsebniPodatkiInSoglasja',
      name: 'OsebniPodatkiInSoglasja',
      component: OsebniPodatkiInSoglasja,
      permissions: ['NAROCNINE_NOSILEC'],
      additionalDataRequired: true
    },
    {
      path: 'UporabnikiInPravice',
      name: 'UporabnikiInPravice',
      component: UporabnikiInPravice,
      permissions: ['STRANKE', 'SHARED_PERMISSIONS', 'SHARED_PERMISSION_REQUESTS'],
      additionalDataRequired: true
    },
    {
      path: 'Racuni',
      name: 'Racuni',
      component: Racuni,
      permissions: ['RACUNI'],
      additionalDataRequired: true
    }
    // { task 122689
    //   path: 'PredplacniskeStoritve',
    //   name: 'PredplacniskeStoritve',
    //   component: PrepaidNarocnine,
    //   permissions: ['PREPAID_NAROCNINE'],
    //   additionalDataRequired: true
    // }
  ]
}

let Poraba = {
  path: '/Poraba',
  component: DashboardLayout,
  redirect: '/Poraba/PorabaTelefonija',
  permissions: [
    'PRIKLJUCKI[tip_prikljucka]=FIX',
    'PORABA_TELEFONIJA',
    'ADMIN_PORABA_TELEFONIJA',
    'PRIKLJUCKI[tip_prikljucka]=OTT'
  ],
  additionalDataRequired: true,
  children: [
    {
      path: 'PorabaTelefonija',
      name: 'PorabaTelefonija',
      component: PorabaTelefonija,
      permissions: ['PORABA_TELEFONIJA', 'ADMIN_PORABA_TELEFONIJA'],
      additionalDataRequired: true
    },
    {
      path: 'PorabaTelevizija',
      name: 'PorabaTelevizija',
      component: PorabaTelevizija,
      permissions: ['STRANKE'],
      additionalDataRequired: true
    },
    {
      path: 'PorabaHramba',
      name: 'PorabaHramba',
      component: PorabaHramba,
      permissions: ['STRANKE'],
      additionalDataRequired: true
    }
  ]
}

let Naroci = {
  path: '/Naroci',
  component: DashboardLayout,
  redirect: '/Naroci/NarociT2Paket',
  permissions: [],
  additionalDataRequired: false,
  children: [
    {
      path: 'NarociT2Paket',
      name: 'NarociT2Paket',
      component: NarociT2Paket,
      permissions: ['PRIKLJUCKI_S_TP'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'NarociHramba',
      name: 'NarociHramba',
      component: NarociHramba,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX'],
      additionalDataRequired: true
    },
    {
      path: 'TVsmart',
      name: 'TVsmart',
      component: TVsmart,
      permissions: ['NASTAVITVE_TELEVIZIJA'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'NarociInternet',
      name: 'NarociInternet',
      component: NarociInternet,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'VarnostnaZascita',
      name: 'VarnostnaZascita',
      component: VarnostnaZascita,
      permissions: ['PRIKLJUCKI'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'NarociMobilnaTelefonija',
      name: 'NarociMobilnaTelefonija',
      component: NarociMobilnaTelefonija,
      permissions: ['UMTS_TELEFONIJA'],
      additionalDataRequired: true
    },
    {
      path: 'NarociTelefonija',
      name: 'NarociTelefonija',
      component: NarociTelefonija,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX', 'PRIKLJUCKI[tip_prikljucka]=UMTS'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'NarociTelevizija',
      name: 'NarociTelevizija',
      component: NarociTelevizija,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX', 'PRIKLJUCKI[tip_prikljucka]=OTT'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    }
  ]
}

let Nastavitve = {
  path: '/Nastavitve',
  component: DashboardLayout,
  redirect: '/Nastavitve/NastavitveTelefonija',
  permissions: [],
  additionalDataRequired: false,
  children: [
    {
      path: 'NastavitveTelefonija',
      name: 'NastavitveTelefonija',
      component: NastavitveTelefonija,
      permissions: ['NASTAVITVE_TELEFONIJA'],
      additionalDataRequired: true
    },
    {
      path: 'NastavitveTelevizija',
      name: 'NastavitveTelevizija',
      component: NastavitveTelevizija,
      permissions: ['NASTAVITVE_TELEVIZIJA'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'NastavitveMreznaOprema',
      name: 'NastavitveMreznaOprema',
      component: NastavitveMreznaOprema,
      permissions: ['TR_OPREMA'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'NastavitveElektronskaPosta',
      name: 'NastavitveElektronskaPosta',
      component: NastavitveElektronskaPosta,
      permissions: ['EMAIL', 'PRIKLJUCKI[tip_prikljucka]=FIX', 'PRIKLJUCKI[tip_prikljucka]=OTT'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'SpletnaPredstavitev',
      name: 'SpletnaPredstavitev',
      component: SpletnaPredstavitev,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK
    },
    {
      path: 'ClientServise',
      name: 'ClientServise',
      component: ClientServise,
      permissions: ['CLIENT_DATA'],
      additionalDataRequired: false
    },
    {
      path: 'T2Cloud',
      name: 'T2Cloud',
      component: T2Cloud,
      permissions: ['OPEN_STACK_PROJECT_OWNER', 'OPEN_STACK_PROJECT_MAINTAINER', 'OPEN_STACK_PROJECT_USER'],
      accessWithPermissionRequests: ['OPEN_STACK_PROJECT_MAINTAINER', 'OPEN_STACK_PROJECT_USER'],
      additionalDataRequired: true
    }
  ]
}

let UporabniskiKoticek = {
  path: '/UporabniskiKoticek',
  component: DashboardLayout,
  redirect: '/UporabniskiKoticek/OMojemT2',
  permissions: [],
  additionalDataRequired: true,
  children: [
    {
      path: 'OMojemT2',
      name: 'OMojemT2',
      component: OMojemT2,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX', 'PRIKLJUCKI[tip_prikljucka]=UMTS'],
      additionalDataRequired: false
    },
    {
      path: 'UporabneStrani',
      name: 'UporabneStrani',
      component: UporabneStrani,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=OTT', 'PREPAID_PRIKLJUCKI'],
      additionalDataRequired: false
    },
    {
      path: 'T2Aplikacije',
      name: 'T2Aplikacije',
      component: T2Aplikacije,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX', 'PRIKLJUCKI[tip_prikljucka]=UMTS'],
      additionalDataRequired: false
    },
    {
      path: 'PosljiSms',
      name: 'PosljiSms',
      component: PosljiSms,
      permissions: ['SMS_POSILJANJE'],
      additionalDataRequired: true,
      defaultConnectorType: PrivzetaVrednostTipEnum.MOBILNA_ST
    },
    {
      path: 'Ambasador',
      name: 'Ambasador',
      component: Ambasador,
      permissions: ['PRIKLJUCKI[tip_prikljucka]=FIX', 'PRIKLJUCKI[tip_prikljucka]=UMTS'],
      additionalDataRequired: true
    }
  ]
}

let Domov = {
  path: '/Domov',
  component: DashboardLayout,
  redirect: '/Domov/NaslovnaStran',
  permissions: [],
  additionalDataRequired: false,
  children: [
    {
      path: 'NaslovnaStran',
      name: 'NaslovnaStran',
      component: NaslovnaStran,
      permissions: ['STRANKE'],
      additionalDataRequired: false
    }
  ]
}

let Piskotki = {
  path: '/Piskotki',
  component: DashboardLayout,
  redirect: '/Piskotki/Podrobnosti',
  permissions: [],
  additionalDataRequired: false,
  children: [
    {
      path: 'Podrobnosti',
      name: 'Podrobnosti piskotkov',
      component: CookiesPage,
      permissions: [],
      additionalDataRequired: false
    }
  ]
}

let Poslovalnice = {
  path: '/Poslovalnice',
  beforeEnter () {
    window.open(povezave.BASE_URL_POSLOVALNICE)
  },
  permissions: [],
  additionalDataRequired: false
}

let Domov2 = {
  path: '/',
  component: DashboardLayout,
  redirect: '/Domov/NaslovnaStran',
  permissions: [],
  additionalDataRequired: false,
  children: [
    {
      path: 'NaslovnaStran',
      name: 'NaslovnaStran2',
      component: NaslovnaStran,
      permissions: [],
      additionalDataRequired: false
    }
  ]
}

let NotFoundRoute = {
  name: 'NotFound',
  path: '*',
  component: NotFound,
  permissions: [],
  additionalDataRequired: false,
  children: []
}

let NotFoundPage = {
  name: 'NotFoundPage',
  path: '/NotFound',
  component: NotFound,
  permissions: [],
  additionalDataRequired: false,
  children: []
}

const routes = [
  racun,
  Domov,
  Domov2,
  MojProfil,
  Poraba,
  Naroci,
  Poslovalnice,
  Nastavitve,
  UporabniskiKoticek,
  NotFoundRoute,
  NotFoundPage,
  Piskotki
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js